// extracted by mini-css-extract-plugin
module.exports = {"button":"_2kuqMxnzpmHrTGSXk7PQJQ==","ShippingInformationAlert":"UIFu5yMET-0CNfVWMXYJJQ=="};